import { makeAutoObservable } from "mobx";
import { getPageAllPatient } from "./AllTbPatientService";

export default class AllTbPatientStore {
  patientList = [];
  totalElements = 0;
  totalPages = 0;
  page = 1;
  rowsPerPage = 5;
  searchObject = {
    keyword: "",
  };

  resetStore = () => {
    this.page = 1;
    this.rowsPerPage = 5;
    this.patientList = [];
    this.totalElements = 0;
    this.totalPages = 0;
  };

  constructor() {
    makeAutoObservable(this);
  }

  updatePageData = (item) => {
    let searchObject = {
      pageIndex: this.page,
      pageSize: this.rowsPerPage,
      keyword: this.searchObject.keyword || "",
    };
    if (item != null) {
      searchObject.pageIndex = this.page = 1;
      this.searchObject.keyword = searchObject.keyword = item.keyword;
    }
    getPageAllPatient(searchObject)
      .then((res) => {
        this.handleSelectPage(res);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  handleSelectPage = (res) => {
    this.patientList = res?.data?.content || [];
    this.totalElements = res?.data?.totalElements || 0;
    this.totalPages = res?.data?.totalPages || 0;
  };

  setPage = (page) => {
    this.page = page;
    this.updatePageData();
  };

  setRowsPerPage = (event) => {
    this.rowsPerPage = event.target.value;
    this.page = 1;
    this.updatePageData();
  };

  handleChangePage = (event, newPage) => {
    this.setPage(newPage);
  };
}
